import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from '../../../styles/bantrab/components/input.module.scss'

import Password from './password'
import Phone from './phone'
import Search from './search'

const Input = ({ placeholder, text, textColor, color, inputType, icon, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'pl-4',
      'pr-4'
    ],
    {
      [styles.input]: true
    }
  )

  return (
    <input type={inputType} placeholder={placeholder} {...attrs} />
  )
}

Input.propTypes = {
  // children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // solid: PropTypes.bool,
  // borderActiveColor: PropTypes.oneOf(['light-green']),
  // text: PropTypes.bool,
  // textColor: PropTypes.oneOf(['light-gray', 'dark-gray']),
  // outline: PropTypes.bool,
  // disabled: PropTypes.bool
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // placeholder: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textColor: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  inputType: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

Input.Password = Password
Input.Phone = Phone
Input.Search = Search

export default Input
